export function isUnrecognizedPreferenceKeysError(error: unknown): boolean {
  const response = (
    error as {
      response?: { status?: number; data?: { details?: Record<string, string> } };
    }
  )?.response;

  if (response?.status !== 422 || !response.data?.details) {
    return false;
  }

  return Object.values(response.data.details).some((message) =>
    /unrecognized key/i.test(message),
  );
}
